import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to the top whenever the pathname (or search) changes.
 * Hash-only changes are skipped so existing anchor-scroll behaviour (handled
 * by useSmoothScroll / individual pages) keeps working.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Don't fight an in-page anchor jump.
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}
